export function chartWorker(
	data,
	flag,
	maxs,
	mins,
	lastTradePrice,
	coin,
	currentTab
) {
	let graphData;
	let chartData;
	let stateMin;
	let stateMax;
	let tab;
	// const usdMultiplier = shownMarket === 1 ? 1 / usdRate : 1;

	switch (flag) {
		case 0:
			try {
				if (data) {
					graphData = JSON.parse(data);
					const min = Math.min.apply(null, graphData);
					mins.y = min;

					const max = Math.max.apply(null, graphData);
					maxs.y = max;

					chartData = graphData.map(el => ({
						name: el.time,
						[coin]: el.price,
					}));
					stateMin = Math.min(
						min,
						lastTradePrice !== 0 ? lastTradePrice : min,
						mins.d !== 0 ? mins.d : min,
						mins.w !== 0 ? mins.w : min
					);
					stateMax = Math.max(
						max,
						lastTradePrice,
						maxs.d !== 0 ? maxs.d : max,
						maxs.w !== 0 ? maxs.w : max
					);
					tab = flag;
				}
			} catch (error) {
				console.log('graph worker', error);
			}

			break;
		case 1:
			try {
				if (data) {
					graphData = JSON.parse(data);

					const min = Math.min.apply(null, graphData);
					mins.w = min;

					const max = Math.max.apply(null, graphData);
					maxs.w = max;

					chartData = graphData.map(el => ({
						name: el.time,
						[coin]: el.price,
					}));
					stateMin = Math.min(
						min,
						lastTradePrice !== 0 ? lastTradePrice : min,
						mins.d !== 0 ? mins.d : min
					);
					stateMax = Math.max(
						max,
						lastTradePrice,
						maxs.d !== 0 ? maxs.d : max
					);
					tab = flag;
				}
			} catch (error) {
				console.log('graph worker', error);
			}
			break;

		case 2:
			try {
				if (data) {
					graphData = JSON.parse(data);

					const min = Math.min.apply(null, graphData);
					mins.d = min;

					const max = Math.max.apply(null, graphData);

					maxs.d = max;

					chartData = graphData.map(el => ({
						name: el.time,
						[coin]: el.price,
					}));
					stateMin = Math.min(
						min,
						lastTradePrice !== 0 ? lastTradePrice : min
					);
					stateMax = Math.max(max, lastTradePrice);
					tab = flag;
				}
			} catch (error) {
				console.log('graph worker', error);
			}
			break;
		default:
			tab = currentTab;
			break;
	}
	return {
		chartData,
		stateMin,
		stateMax,
		tab,
	};
}
